import $ from "jquery";
import "bootstrap";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faA, faBars } from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faInstagram, faLinkedin, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";
import "./custom.scss";
import "./styles/main.css";
import tableData from "./data.json";

// redirect if name != /virtual-appliance-lookup/
if (window.location.pathname === "/virtual-appliance-lookup") { window.location.replace("/virtual-appliance-lookup/" + window.location.search + window.location.hash) }

library.add(faFacebook, faInstagram, faLinkedin, faTwitter, faYoutube, faBars);
dom.watch();


function renderLink(data, type, row) {
    return data ? `<a href="${data}" target="_blank">Link</a>` : "none";
}

function renderVendor(data, type, row) {
    switch (data) {
        case "GCP":
            return `Google Cloud Platform (GCP)`;
        case "AWS":
            return `Amazon Web Services (AWS)`;
        case "Azure":
            return "Microsoft Azure";
        default:
            return data;
    }
}

function renderOSType(data, type, row) {
    return data.replace('linux', 'Linux');
}

$('#table').DataTable({
    data: tableData,
    responsive: true,
    columns: [
        { data: "Image Name" },
        { data: "Software Release" },
        { data: "OS Type", render: renderOSType },
        { data: "Vendor", render: renderVendor },
        { data: "Hosted Link", render: renderLink },
        { data: "Doc Link", render: renderLink },
    ],
});
